// create a ModalComponent inherited from component
import Component from './component';
import utils from '../utils';
import 'base_global_css/components/modal.scss';
var DOMPurify = require('dompurify');
/**
 * Modal component extended from component
 */
class ModalComponent extends Component {
    constructor(el, id) {
        super(el, id);
        this.defaultAnimation = 'fade';
        this.modalId = el.dataset.modalId || el.dataset.comp;
        this.modalClassName = el.dataset.modalClassname || '';
        this.options = {
            type: this.el.dataset.type || this.defaultAnimation,
            classNames: `${this.modalId.toLowerCase()} ${this.name.toLowerCase()} ${this.modalClassName}`
        };
        // this flag prevents duplicate call from happening
        this.isLoading = false;
        this.el.classList.add('modal-component');
        // eslint-disable-next-line
        this._bindEvents();
    }

    /**
     * get modal HTML
     * @param {string} id modalID
     * @param {Object} data modal data
     * @param {Object} option modal options
     * @returns {string} modal html content
     */
    getModalHtmlElement(id, data, option = this.options) {
        const header = data.header ? `<h1 class="modal-title ${id}__modal-title">${data.header}</h1>` : '';
        const footer = data.footer ? `<div class="modal-footer ${id}__modal-footer">${data.footer}</div>` : '';
        const htmlString =
        `<div class="modal ${option.classNames} ${option.type}" id="${id}" role="dialog" tabindex="-1">
            <span class="enter-message sr-only"></span>
            <div class="modal-dialog ${id}__modal">
                <!-- Modal content-->
                <div class="modal-content ${id}__modal-content">
                    <div class="modal-header ${id}__modal-head">
                        ${header}
                        <div class="modal-close">
                            <button type="button" class="close" data-dismiss="modal">
                                <span aria-hidden="true" class="icon-close"></span>
                                <span class="sr-only"> </span>
                            </button>
                        </div>
                    </div>
                    <div class="modal-body ${id}__modal-body">
                        ${data.body}
                    </div>
                    ${footer}
                </div>
            </div>
        </div>`;

        return htmlString;
    }

    /**
     * Bind all modal events
     */
    _bindEvents() {
        $('body').on('click', '[data-modal]', (event) => {
            // ignore click if there is previous click in process
            if (this.isLoading) return;
                // open the modal if the element clicked has data-modal name
                // which matches. This can have it just load or reload the modal
                // with content from another modalurl
            if (event.currentTarget.dataset.modal === this.modalId) {
                const modalUrl = event.target.dataset.modalurl || false;

                // open the modal with path and second argument is boolean
                // which determine whether to replace existing modal or use it
                this.isLoading = true;

                if (modalUrl) {
                    this.open(modalUrl);
                } else {
                    this.open();
                }
            }
        });
    }

    createModal(data) {
        // when first loaded data is empty and hence this block is skipped.
        // when click to open the modal , fetchContent is called which update the state
        // which inturn call enable again, this time with data true
        // this will execute this block and then open the modal
        if (data) {
            this.destroy();
            this.$el.append(this.getModalHtmlElement(this.modalId, {
                header: DOMPurify.sanitize(data.header || false),
                body: DOMPurify.sanitize(data.body || false),
                footer: DOMPurify.sanitize(data.footer || false)
            }, this.options));
            // enable is fired when loaded with data false which will skip this block
            // when clicked to open , state is checked and fetch is fired which will call
            // enable again and then open will be called
            this.open();
        }

        this.el.classList.add('modal-created');
    }

    enable() {
        if (this.state.data) {
            this.createModal(this.state.data);
        }
    }

    /**
     * Open modal
     * @param {URL|string} path - Modal URL
     */
    open(path) {
        // reset state if new path requested
        if (path) {
            this.state = {};
        }

        const modalurl = path || this.el.dataset.modalurl || '';

        // if modalurl exists and state is reset then fetch content again else open the modal
        if (modalurl && !this.state.data) {
            this.fetchContent(modalurl, () => {
                this.isLoading = false;
            });
        } else if (this.state.data || (!modalurl && !this.state.data)) {
            var curScrollPosition = $(window).scrollTop();
            utils.openModal($(`#${this.modalId}`));
            if (utils.getCurrentBreakpoint() === 'mobile') {
                $('html, body').animate({ scrollTop: curScrollPosition }, 0);
            }
            const modalContent = $('.modal-content', this.$el)[0];
            if (modalContent) {
                modalContent.scrollTop = 0;
            }
            this.isLoading = false;
            this.onOpen();
        }
    }

    /**
     * close modal
     */
    close() {
        utils.closeModal($(`#${this.modalId}`));
    }

    /**
     * remove modal
     */
    destroy() {
        $(`#${this.modalId}`).remove();
    }

    // Interface created of additional work that can be done in modal specific files
    onOpen() {}


}

export default ModalComponent;
